import React, { Component } from 'react';
import { MessageCircle } from 'lucide-react';
const PHONE_NUMBER = '2066193742';
const DEFAULT_MESSAGE = "Hi, I'm on your website and I have a question";
export function LiveChat() {
  const smsLink = `sms:${PHONE_NUMBER}?body=${encodeURIComponent(DEFAULT_MESSAGE)}`;
  return <div className="hidden md:flex fixed bottom-6 right-6 z-50 flex-col items-end" data-id="element-535">
      <a href={smsLink} className="w-14 h-14 rounded-full shadow-lg flex items-center justify-center transition-transform hover:scale-105 bg-[#05894d] text-white" aria-label="Text Us" data-id="element-536">
        <MessageCircle className="w-6 h-6" data-id="element-537" />
      </a>
    </div>;
}